import React from 'react'
import { useMapContext } from '../MapContext'
import s from '../tools/ZoomButtons.less'

export default function ZoomDebugger() {
  const mapContext = useMapContext()
  const rawZoom = mapContext.map?.getZoom?.() || 0
  const zoom = Math.floor(rawZoom * 1000) / 1000

  return <div className={s.ZoomDebugger}>Zoom: {zoom}</div>
}
